import React from 'react';
import {Router, RouterProps} from '@reach/router';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import routeService from './routes';

const AppRouter = (
  props: RouterProps & Omit<React.HTMLProps<HTMLDivElement>, 'ref'>,
) => {
  const appRoutes = routeService.getRoutes();

  return (
    <Router {...props} style={{height: '100%'}}>
      {Object.entries(appRoutes).map(([path, value]) => {
        const {component, ...rest} = value; // Destructure to avoid duplicate `component` prop
        return (
          <PrivateRoute
            key={path}
            path={path}
            component={component as any}
            {...rest}
          />
        );
      })}
    </Router>
  );
};

export default AppRouter;
